module.exports = __webpack_public_path__ + "img/dental-background.84c5660d.png";